/**
 * Pixel-perfect CSS overrides for the GenieCanvas React Flow instance.
 * Extracted from GenieCanvas.tsx — injected via <style dangerouslySetInnerHTML>.
 */

export const CANVAS_STYLES = `
/* ---- Grid ---- */
.react-flow__background pattern line {
  stroke-opacity: 0.08;
}
.react-flow__background pattern line.react-flow__background-line-major {
  stroke-opacity: 0.158;
}

/* ---- Selection box ---- */
.react-flow__selection {
  border: 1px solid #1fb6ff !important;
  background: rgba(31, 182, 255, 0.1) !important;
  z-index: 1000 !important;
}
.react-flow__nodesselection-rect {
  border: 1px solid #1fb6ff !important;
  background: rgba(31, 182, 255, 0.1) !important;
}

/* ---- Nodes ---- */
.react-flow__node {
  border: none !important;
  background: transparent !important;
  z-index: 100;
  backface-visibility: hidden;
  perspective: 1000px;
  contain: layout style;
}

/* Corner resize. Edge lines stay out of the port hit targets. */
.react-flow__resize-control.line.genie-node-resize-line {
  border-color: transparent !important;
  pointer-events: none !important;
}
.react-flow__resize-control.handle.genie-node-resize-handle {
  width: 12px;
  height: 12px;
  border: 1.5px solid #171717;
  border-radius: 2px;
  background: #fff;
  z-index: 20;
}
.dark .react-flow__resize-control.handle.genie-node-resize-handle {
  border-color: #fafafa;
  background: #171717;
}
.dark .react-flow__node {
  background: transparent !important;
}
.react-flow__node.selected,
.react-flow__node:hover:not(.selected),
.react-flow__node.dragging {
  border: none !important;
}

/* ---- Handles ---- */
.react-flow__handle {
  z-index: 10;
}

/* ---- Edges ---- */
.react-flow__edge path {
  stroke: #999;
  stroke-width: 1.5;
  transition: stroke-width 0.15s ease, stroke 0.15s ease;
}
.dark .react-flow__edge path {
  stroke: #777;
}
.react-flow__edge.selected path {
  stroke: #1fb6ff;
  stroke-width: 2;
}
.react-flow__edge:hover path {
  stroke: #3b82f6;
  stroke-width: 2;
}
.react-flow__edge.updating path {
  stroke: #94a3b8;
}

/* ---- Crosshair snap guide ---- */
.react-flow__helper-lines {
  stroke-width: 1;
  opacity: 0.15;
}

/* ---- Z-index layers ---- */
.react-flow__nodes {
  z-index: 100;
}
.react-flow__selectionpane {
  z-index: 1000;
}
.react-flow__panel.react-flow__attribution {
  display: none;
}

/* ---- Canvas cursor: override React Flow grab defaults ---- */
.react-flow__pane {
  cursor: inherit !important;
}
.dark .react-flow__pane {
  cursor: inherit !important;
}

/* ---- Tooltips (future) ---- */
.react-flow__tooltip {
  z-index: 9999;
}

/* ---- MiniMap ---- */
.react-flow__minimap {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  overflow: hidden;
}
.dark .react-flow__minimap {
  border-color: #374151;
  background: #111827;
}

/* ---- Controls ---- */
.react-flow__controls {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  overflow: hidden;
}
.dark .react-flow__controls {
  border-color: #374151;
}
.dark .react-flow__controls button {
  background: #1f2937;
  color: #e5e7eb;
  border-bottom-color: #374151;
}
.dark .react-flow__controls button:hover {
  background: #374151;
}

/* ---- Hide controls when sidebar is expanded ---- */
.sidebar-expanded .react-flow__controls {
  display: none !important;
}

/* ---- LOD: Reduced detail (zoom < 0.6) ---- */
.react-flow[data-lod="reduced"] .react-flow__node {
  box-shadow: none !important;
  transition: none !important;
  animation: none !important;
}
.react-flow[data-lod="reduced"] .react-flow__node img,
.react-flow[data-lod="reduced"] .react-flow__node video {
  transition: none !important;
}
.react-flow[data-lod="reduced"] .react-flow__edge path {
  transition: none !important;
}

/* ---- LOD: Minimal detail (zoom < 0.35) ---- */
/* Nodes auto-collapse to compact bar (icon + title) via NodeContainer */
.react-flow[data-lod="minimal"] .react-flow__node {
  box-shadow: none !important;
  transition: none !important;
}
.react-flow[data-lod="minimal"] .react-flow__edge path {
  transition: none !important;
  stroke-width: 1 !important;
}

/* ---- LOD: Ultra minimal detail (zoom < 0.15) ---- */
.react-flow[data-lod="ultra"] .react-flow__node {
  box-shadow: none !important;
  transition: none !important;
  animation: none !important;
  border-radius: 4px !important;
}
.react-flow[data-lod="ultra"] .react-flow__node * {
  visibility: hidden !important;
}
.react-flow[data-lod="ultra"] .react-flow__node::after {
  content: '';
  visibility: visible !important;
  display: block;
  position: absolute;
  inset: 0;
  border-radius: 4px;
  background: var(--node-color, #e5e7eb);
}
.react-flow[data-lod="ultra"] .react-flow__edge path {
  transition: none !important;
  stroke-width: 0.5 !important;
}
.react-flow[data-lod="ultra"] .react-flow__handle {
  display: none !important;
}

/* ---- Edge animation (GPU-composited) ---- */
@keyframes edgeFlow {
  to { stroke-dashoffset: -10; }
}
.edge-animated {
  animation: edgeFlow 0.5s linear infinite;
  will-change: stroke-dashoffset;
}
`
